<template>
  <div id="BiddingAwardComponent" class="layout-bidding-all">
    <!-- <v-card outlined>
      <v-card-title>PO File</v-card-title>
    </v-card> -->
    <v-card outlined
      ><v-card-title>Acknowledge PO</v-card-title>
      <v-card-text>
        <!-- <v-row align="center">
          <v-col cols="12">
            <v-btn
              class="mr-4"
              outlined
              color="primary"
              @click="downloadOP()"
              target="_blank"
              :loading="progressBar"
            >
              <v-icon left> mdi-cloud-download </v-icon>
              Download {{ ProjectAward.attachFileProcurementPoName }}
            </v-btn>
          </v-col>
          <v-col cols="6" v-if="propBiddingStatus === 'Not Start'">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-file-input
                label="Price Offer Confirmation"
                outlined
                dense
                show-size
                accept=".pdf"
                :rules="
                  ProjectAward.attachFilePoName
                    ? false
                    : [(v) => !!v || 'File input is required']
                "
                required
                v-model="fileOp"
              ></v-file-input>
            </v-form>
          </v-col>
          <v-col cols="10" v-else>
            <v-btn
              outlined
              color="secondary"
              @click="
                getFileAtachment(
                  ProjectAward.attachFilePo,
                  ProjectAward.attachFilePoName
                )
              "
              target="_blank"
              :loading="progressBar"
            >
              <v-icon left> mdi-cloud-download </v-icon>
              {{
                ProjectAward.attachFilePoName !== null
                  ? ProjectAward.attachFilePoName
                  : "No File"
              }}
            </v-btn></v-col
          ></v-row
        > -->
        <v-data-table :headers="headerPO" :items="poItems">
          <template v-slot:[`item.attachFilePoName`]="{ item }">
            <v-btn
              v-if="item.attachFilePo"
              outlined
              color="success"
              @click="downloadOPFiles(item.attachFilePo, item.attachFilePoName)"
              target="_blank"
              :loading="progressBar"
            >
              <v-icon left> mdi-cloud-download </v-icon>
              Download
            </v-btn>
            <!-- <a
              class="secondary--text text-decoration-underline"
              @click="downloadOPFiles(item.attachFilePo, item.attachFilePoName)"
              rel="noopener noreferrer"
              >Download
            </a> -->
          </template>
          <template v-slot:[`item.vendorAttachFilePoName`]="{ item }">
            <div v-if="item.attachFilePo">
              <div v-if="!item.vendorAttachFilePoName">
                <v-file-input
                  class="mt-5"
                  label="Upload Acknowledge PO"
                  outlined
                  dense
                  show-size
                  accept=".pdf"
                  :rules="[
                    (v) => {
                      if (!v) return 'File input is required';
                      const ext = v.name.split('.').pop().toLowerCase();
                      if (ext !== 'pdf') return `File type .${ext} not allowed`;
                      const maxSize = 31457280;
                      return v.size <= maxSize || 'File size must be less than or equal to 30MB';
                    }
                  ]"
                  required
                  v-model="item.poFileTemp"
                ></v-file-input>
                <v-btn
                  class="mb-5 ml-8"
                  outlined
                  color="primary"
                  :disabled="!isFileValid(item.poFileTemp)"
                  @click="DialogUploadPO(item.poFileTemp, item.attachId)"
                  target="_blank"
                  :loading="progressBar"
                >
                  <v-icon left> mdi-cloud-upload </v-icon>
                  Upload
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  outlined
                  color="success"
                  @click="
                    getFileAtachment(
                      item.vendorAttachFilePo,
                      item.vendorAttachFilePoName
                    )
                  "
                  target="_blank"
                  :loading="progressBar"
                >
                  <v-icon left> mdi-cloud-download </v-icon>
                  Download
                </v-btn>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card outlined class="mt-6"
      ><v-card-title>Bidding Items Award </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="ProjectAward.item">
          <template v-slot:[`item.offerUnitPrice`]="{ item }">
            {{
              isRound === 1
                ? item.offerUnitPrice === null
                  ? 0
                  : item.offerUnitPrice
                : item[`offerUnitPriceRound${isRound}`] === null
                ? 0
                : item[`offerUnitPriceRound${isRound}`]
            }}
          </template>
          <template v-slot:[`item.offerTotalAmount`]="{ item }">
            {{
              isRound === 1
                ? setTotal(item.offerUnitPrice, item)
                : setTotal(item[`offerUnitPriceRound${isRound}`], item)
            }}
          </template>
          <template v-slot:[`item.remarkNoOffer`]="{ item }">
            <p v-if="isRound === 1">
              {{ item.remarkNoOffer === null ? "-" : item.remarkNoOffer }}
            </p>
            <p v-else>
              {{
                item[`remarkNoOfferRound${isRound}`] === null
                  ? "-"
                  : item[`remarkNoOfferRound${isRound}`]
              }}
            </p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip small dark :color="item.isAward ? 'green' : ''">
              {{ item.isAward ? "Award" : "Not Award" }}
            </v-chip>
          </template>
          <template v-slot:[`item.isNoOffer`]="{ item }">
            <v-checkbox
              disabled
              v-if="isRound === 1"
              v-model="item.isNoOffer"
            ></v-checkbox>
            <v-checkbox
              disabled
              v-else
              v-model="item[`isNoOfferRound${isRound}`]"
            ></v-checkbox
          ></template> </v-data-table
      ></v-card-text>
      <v-card-text v-if="ProjectAward.itemCurrency !== undefined">
        <p>
          Estimated total price in THB : rate
          {{ ProjectAward.itemCurrency.rate }}
        </p>
        <h2 v-if="isRound === 1">
          {{ totalAmount === null ? 0 : numberBaht(totalAmount) }}
        </h2>
        <h2 v-if="isRound === 2">
          {{ totalAmountRound2 === null ? 0 : numberBaht(totalAmountRound2) }}
        </h2>
        <h2 v-if="isRound === 3">
          {{ totalAmountRound3 === null ? 0 : numberBaht(totalAmountRound3) }}
        </h2>
        <h2 v-if="isRound === 4">
          {{ totalAmountRound4 === null ? 0 : numberBaht(totalAmountRound4) }}
        </h2>
        <h2 v-if="isRound === 5">
          {{ totalAmountRound5 === null ? 0 : numberBaht(totalAmountRound5) }}
        </h2>
        <h2 v-if="isRound === 6">
          {{ totalAmountRound6 === null ? 0 : numberBaht(totalAmountRound6) }}
        </h2>
      </v-card-text>
    </v-card>

    <!-- Confirm dialog -->
    <v-dialog v-model="dialog.show" width="500">
      <v-card>
        <v-card-title
          :class="
            dialog.type === 'error' ? 'red lighten-4' : 'light-green lighten-4'
          "
        >
          Confirm Acknowledge PO
        </v-card-title>
        <v-card-text class="mt-2">
          Please make sure your PO is correctly, If you click SUBMIT button you
          cann't change your PO anymore.</v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="uploadPO">
            {{
              dialog.type === "success"
                ? "Join"
                : dialog.type === "error"
                ? "Close"
                : "Submit"
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";
import { numberFormat } from "../../../services/utility";
import { masterservice } from "../../../services/masterservice";
import blobToBase64 from "../../../util/img-to-base64";

export default {
  name: "BiddingAwardComponent",
  props: {
    propBiddingStatus: {
      type: String,
      default: () => "",
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  data() {
    return {
      valid: true,
      ProjectAward: {},
      isRound: 0,
      totalAmount: 0,
      totalAmountRound2: 0,
      totalAmountRound3: 0,
      totalAmountRound4: 0,
      totalAmountRound5: 0,
      totalAmountRound6: 0,
      dataExchangeRate: [],
      selectedCurrency: {
        exchId: 0,
        exchange: "",
        rate: 0,
        exchDate: "",
      },
      attachmentModel: {
        projectVendorSubmitAttachId: 0,
        projectId: this.$route.params.projectId,
        vendorId: this.$store.state.AppActiveUser.vendorID,
        isActive: true,
      },
      fileOp: null,
      progressBar: false,
      headers: [
        {
          text: "Company",
          align: "start",
          sortable: false,
          value: "companyFullName",
        },
        { text: "Product / Service Name", value: "shortDescription" },
        { text: "Spec", value: "longDescription" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit of Measures", value: "unitOfMeasureName" },
        { text: "Unit Price", value: "offerUnitPrice" },
        { text: "Contract Period (Month)", value: "itemPeriod" },
        { text: "Total Amount", value: "offerTotalAmount" },
        { text: "Offer", value: "isNoOffer" },
        { text: "Result", value: "remarkNoOffer" },
        { text: "Status", value: "status" },
      ],

      headerPO: [
        {
          text: "Company",
          align: "start",
          sortable: false,
          value: "companyFullName",
        },
        { text: "PO Number", value: "ponumber" },
        { text: "PO File", value: "attachFilePoName" },
        { text: "Acknowledge PO", value: "vendorAttachFilePoName" },
      ],

      poItems: [],
      isSubmitAllPO: false,

      dialog: {
        show: false,
        title: "",
        text: "",
        type: "",
      },

      itemSubmitPO: {
        poFile: "",
        attachId: 0,
      },
    };
  },
  computed: {
    vendorId() {
      return this.$store.state.AppActiveUser.vendorID;
    },
  },
  watch: {
    propCheckStep(value) {
      if (value === 3) {
        this.$loading(true);
        Promise.all([this.getDataBiddingProject()]).then(() => {
          this.calculateTotalAmount();
          this.$loading(false);
        });
      }
      if (value === 4) {
        // if (this.ProjectAward.attachFilePoName) {
        this.$emit("emitSubmitAttachmentStep4Next", true);
        /* } else {
          this.validate();
        } */
      }
    },
  },
  methods: {
    async validate() {
      await this.$refs.form.validate();
      if (this.valid === true) {
        this.saveAttachment();
      } else {
        this.$emit("emitSubmitAttachmentStep4Next", false);
      }
    },
    async getDataBiddingProject() {
      // Get PO item for Acknowledge
      this.getPOitem();

      const result =
        await _projectservice.GetBiddingProjectVendorSubmitItemNegotiate(
          this.$route.params.projectId,
          this.vendorId
        );
      const round = result.length;
      if (round <= 1 || round === undefined) {
        const resultOldDetail = await _projectservice.GetBiddingDetail(
          this.$route.params.projectId,
          this.vendorId
        );
        let biddingProject = resultOldDetail;
        const r = resultOldDetail.length;

        const returnSetData = await this.setDataForGetProject(biddingProject);
        this.ProjectAward = returnSetData[r - 1];
        this.ProjectAward.biddingRound = resultOldDetail[r - 1].biddingRound;
        this.ProjectAward.attachFilePo = returnSetData[r - 1].attachFilePo;
        this.ProjectAward.attachFilePoName =
          returnSetData[r - 1].attachFilePoName;
        this.isRound = resultOldDetail[r - 1].biddingRound;
        this.$emit("emitAttachmentAlreadyExist", returnSetData[r - 1]);
      } else {
        const returnSetData = await this.setDataForGetProject(result);
        this.ProjectAward = returnSetData[round - 1];
        this.ProjectAward.attachFilePo = returnSetData[round - 1].attachFilePo;
        this.ProjectAward.attachFilePoName =
          returnSetData[round - 1].attachFilePoName;
        this.isRound = result[round - 1].biddingRound;
        this.$emit("emitAttachmentAlreadyExist", returnSetData[round - 1]);
      }
    },
    async getPOitem() {
      this.poItems =
        await _projectservice.GetBiddingProjectSelectedVendorSplitPo(
          this.$route.params.projectId,
          this.vendorId
        );
      // Set Submit all po
      this.isSubmitAllPO =
        this.poItems[this.poItems.length - 1].isVendorSubmitedAllPo;

      // Set PO attachment
      this.poItems = this.poItems[this.poItems.length - 1].submitPoAttachments;

      // console.log(this.poItems);
    },
    number(number) {
      if (number != null) return numberFormat(number);
    },
    numberBaht(number) {
      if (number != null)
        return number.toLocaleString("th-TH", {
          style: "currency",
          currency: "THB",
        });
    },
    calGrandTotal(dataPrice, index) {
      return index === 0
        ? dataPrice.reduce(
            (acc, item) => acc + item.offerUnitPrice * item.quantity,
            0
          )
        : dataPrice.reduce(
            (acc, item) =>
              acc + item[`offerUnitPriceRound${index + 1}`] * item.quantity,
            0
          );
    },
    setTotal(price, item) {
      price = price !== null ? price : 0;
      const quantity = item.quantity !== null ? item.quantity : 0;
      return price * quantity;
    },
    async setDataForGetProject(result) {
      for (let i = 0; i < result.length; i++) {
        if (result[i].currencyId === null) {
          result[i].itemCurrency = this.selectedCurrency;
          this.getExchangeRate(null);
        } else {
          const item = await this.getExchangeRate(result[i].currencyId);
          result[i].itemCurrency = item;
        }
      }
      return result;
    },
    async getExchangeRate(id) {
      this.dataExchangeRate = await masterservice.GetMasterExchangeRate(parseInt(this.$route.params.projectId));
      if (id !== null)
        return Promise.all([this.getCurrencyForEdit(id)]).then(
          (result) => result[0]
        );
    },
    getCurrencyForEdit(id) {
      let object = this.dataExchangeRate.find((item) => item.exchId === id);
      this.selectedCurrency = object;
      return object;
    },
    calculateTotalAmount() {
      // this.$validator.validateAll("currency-form").then(async (result) => {
      //   if (result) {
      if (this.isRound === 1) {
        const total = this.ProjectAward.item.reduce((sum, transaction) => {
          const sumprice = transaction.offerUnitPrice * transaction.quantity;
          return (sum += sumprice);
        }, 0);
        this.totalAmount = total * this.ProjectAward.itemCurrency.rate;
      } else {
        const total = this.ProjectAward.item.reduce((sum, transaction) => {
          return (sum +=
            transaction[
              `offerUnitPriceRound${this.ProjectAward.biddingRound}`
            ] * transaction.quantity);
        }, 0);
        this[`totalAmountRound${this.ProjectAward.biddingRound}`] =
          total * this.ProjectAward.itemCurrency.rate;
      }
      //   }
      // });
    },
    async downloadOP() {
      this.progressBar = true;
      /*  await _projectservice.GetBlobFileProject(
        this.ProjectAward.attachFileProcurementPo,
        this.ProjectAward.attachFileProcurementPoName
      ); */
      // console.log("POFile", this.poItems);
      this.progressBar = false;
    },
    async downloadOPFiles(fileSystemName, fileRealName) {
      this.progressBar = true;
      await _projectservice.GetBlobFileProject(fileSystemName, fileRealName);
      this.progressBar = false;
    },
    async getFileAtachment(fileSystemName, fileRealName) {
      this.$loading(true);
      await _projectservice.GetBlobFileVendor(fileSystemName, fileRealName);
      this.$loading(false);
    },
    async uploadPO() {
      // Close dialog
      this.dialog.show = false;

      // console.log(poFile, attachId);
      var poFile = this.itemSubmitPO.poFile;
      var attachId = this.itemSubmitPO.attachId;

      this.$loading(true);
      try {
        const body = {
          attachId: attachId,
          attachFileBase64: await this.setBase64(poFile),
          attachFileId: "",
          attachFileName: poFile.name,
        };

        let result = await _projectservice.SubmitUploadFileRowVendorSplitPo(
          body
        );
        if (result.message === undefined || result.lenght == 0) {
          this.$notify({
            type: "success",
            title: "Acknowledge PO Success.",
            text: "Your attachment have been saved.",
          });
          this.$loading(false);

          // Reload PO attachment
          this.getPOitem();

          // Callback to main for update biddingstatus
          this.$emit("emitVendorAcknowledgePO");
        } else {
          this.$notify({
            type: "error",
            title: "Can't Save Bidding Attachment",
            text: result.message,
          });
          this.$loading(false);
        }
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Can't Save Bidding Attachment",
          text:
            "Please select file in correct format - System : [" + error + "]",
        });
        this.$loading(false);
      }
    },
    async saveAttachment() {
      let listAttachment = [];
      const body = {
        projectVendorSubmitAttachRowId: 0,
        docCode: "D018",
        docType: "Acknowledge PO",
        attachFileBase64: await this.setBase64(this.fileOp),
        attachFileName: this.fileOp.name,
        isActive: true,
      };
      listAttachment.push(body);
      const mapBody = {
        projectVendorSubmitAttachId: 0,
        projectId: +this.$route.params.projectId,
        vendorId: this.vendorId,
        round: this.isRound,
        listAttachment: listAttachment,
      };
      await this.SubmitUploadFile(mapBody);
    },
    async setBase64(file) {
      const blob = await blobToBase64(file);
      const blobBase = blob.split(",");
      return blobBase[1];
    },
    async SubmitUploadFile(body) {
      this.$loading(true);
      try {
        let result = await _projectservice.SubmitUploadFileRow(body);
        if (result.message === undefined || result.lenght == 0) {
          this.$notify({
            type: "success",
            title: "Save Bidding Attachment Success.",
            text: "Your attachment have been saved.",
          });
          this.$emit("emitSubmitAttachmentStep4Next", true);
          this.$loading(false);
        } else {
          this.$notify({
            type: "error",
            title: "Can't Save Bidding Attachment",
            text: result.message,
          });
          this.$emit("emitSubmitAttachmentStep4Next", false);
          this.$loading(false);
        }
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Can't Save Bidding Attachment",
          text: "System : [" + error + "]",
        });
        this.$emit("emitSubmitAttachmentStep4Next", false);
        this.$loading(false);
      }
    },

    isFileValid(file) {
      if (!file) return false;
      
      const ext = file.name.split('.').pop().toLowerCase();
      if (ext !== 'pdf') return false;
      
      const maxSize = 31457280;
      if (file.size > maxSize) return false;
      
      return true;
    },

    DialogUploadPO(poFile, attachId) {
      // Clear model submit PO
      this.itemSubmitPO = {
        poFile: "",
        attachId: 0,
      };

      if (!this.isFileValid(poFile)) return;

      this.dialog.show = true;

      // Set model for submit
      // this.itemSubmitPO.poFile = poFile;
      this.itemSubmitPO = {
        poFile: poFile,
        attachId: attachId,
      };

      // console.log("Dialog test", this.itemSubmitPO);
    },
  },
};
</script>
